import Navbar from "@/components/site/Navbar";
import { Seo } from "@/components/site/Seo";
import Footer from "@/components/site/Footer";
import Timetable from "@/components/site/Timetable";
import TermDates from "@/components/site/TermDates";
import FinalCTA from "@/components/site/FinalCTA";

export default function TimetablePage() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#334155] font-body" data-testid="timetable-page">
      <Seo
        title="Class Timetable & Live Availability | Happy Tiddlers"
        description="Check our weekly swimming class timetable and live availability in Barton-le-Clay. Filter by class, day and open spaces, then book online."
        path="/timetable"
      />
      <Navbar />
      <main>
        <Timetable />
        <TermDates />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
